//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { DEFINE_TYPE, VALUE_TYPE, COLUMN_TYPE, CLASS_OPTIONS } from '@/utils/constant';
import relativeTime from 'dayjs/plugin/relativeTime';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import desc from '@/components/desc';
import descItem from '@/components/desc/item';

dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat);

const textSubtypes = {
  id_card: '身份证',
  phone: '手机号',
  public_attachment: '公有附件',
  private_attachment: '私有附件',
  txmap_poi: '腾讯地图-POI',
};

const FieldDefaults = {
  id: '',
  object_id: '',
  name: '',
  display_name: '',
  description: '',
  define_type: 'PACKAGE',
  column_type: 'STANDARD',
  value_type: 'TEXT',
  format: '',
  update_value: false,
  version: 0,
  is_active: false,
  is_unique: false,
  is_require: false,
  is_dcr: false,
  default: '',
  ext: '',
  create_by: '',
  create_time: '',
  update_by: '',
  update_time: '',
  select_one_option: undefined,
  select_many_option: undefined,
  select_one_int_option: undefined,
  text_option: undefined,
  encrypt: false, // 是否加密
  set_default: false,
};

const copy = (o) => JSON.parse(JSON.stringify(o));

export default {
  name: 'ObjectList',
  components: {
    eDesc: desc,
    eDescItem: descItem,
  },
  data() {
    return {
      DefineType: DEFINE_TYPE,
      ValueType: VALUE_TYPE,
      ColumnType: COLUMN_TYPE,
      classOptions: CLASS_OPTIONS,
      dialogVisible: false,
      dialogIsCreate: false,
      queryParams: {
        object_id: '',
      },
      editingObject: {},
      loading: true,
      list: [],
      formData: {
        id: '',
        object_id: '',
        name: '',
        display_name: '',
        description: '',
        define_type: 'PACKAGE',
        column_type: 'STANDARD',
        value_type: 'TEXT',
        format: '',
        update_value: false,
        version: 0,
        is_active: false,
        is_unique: false,
        is_require: false,
        is_dcr: false,
        default: '',
        ext: '',
        create_by: '',
        create_time: '',
        update_by: '',
        update_time: '',
        select_one_option: undefined,
        select_many_option: undefined,
        select_one_int_option: undefined,
        text_option: undefined,
        encrypt: false, // 是否加密
        set_default: false,
      },
      one_option: [{ value: '', label: '', class: '' }], // 单选选项
      one_int_option: [{ value: '', label: '', class: '' }], // 单选（int）
      many_optio: [{ value: '', label: '', class: '' }], // 多选选项
      oldOptionLen: -1, // 用来记录编辑页面已选选项长度
      // 文本类型
      text_option: {
        type: '', // 子类型
        set_mask: false,
        mask_rule: {
          pattern: '',
          replacement: '',
        },
      },
      disabledTextSubtype: false, // 是否禁用文本子类型下拉框
      disabledIsUnique: false, // 是否禁用唯一选择
      disabledEncrypt: false, // 是否禁用加密
      disabledDCR: false, // 是否禁用dcr
      textSubtypes,
      total: 0,
      // 删除
      indexList: [],
      showIndexList: false,
      deleteField: null,
      autoNumberInfoDialogVisible: false,
      availableFieldName: [],
      fieldNameRegs: [],
      autoNumberIllustrate: [
        {
          format: '{0}',
          required: '必需',
          illustrate:
            '序列编号。包括在花括号中的一个或多个零代表序列编号本身。花括号中零的个数表示将显示的最小数字位数。如果实际编号的位数小于此数，将在其前边置零。',
        },
        {
          format: '{YY}<br>{YYYY}',
          required: '可选',
          illustrate:
            '年份。包括在花括号中的两个或四个"Y"字符，代表记录创建日期的年份。如显示年份的两位（如"23"）或全部的四位（如"2023"）。',
        },
        {
          format: '{MM}',
          required: '可选',
          illustrate:
            '月份。2 花括号中包括的两位字符表示记录创建日期的数字月份（如"01"表示一月，"02"表示二月）。',
        },
        {
          format: '{DD}',
          required: '可选',
          illustrate:
            '日期。2 花括号中包括的两位字符表示记录创建日期的数字日期（如"01"至"31"都是一月的有效日期）。',
        },
        {
          format: '{Columnname}',
          required: '可选',
          illustrate: '字段名，限定在当前对象的字段名，取字段中的值作为编码中的一部分',
        },
      ],
      autoNumberExample: [
        {
          format: '{0}',
          number: '1<br>250<br>5000',
          encodeNumber: '1<br>250<br>5000',
          comment: '无前置零，按序列号实际位数存储。',
        },
        {
          format: '{000}',
          number: '1<br>250<br>5000',
          encodeNumber: '001<br>250<br>5000',
          comment: '包括前置零，最多 3 位，超过则按实际序号展示。',
        },
        {
          format: '{000000}',
          number: '1<br>250<br>5000',
          encodeNumber: '000001<br>000250<br>005000',
          comment: '包括前置零，最多 6 位，超过则按实际序号展示。',
        },
        {
          format: '{YYYY}{MM}-{0}',
          number: '1<br>250<br>5000',
          encodeNumber: '202301-1<br>202301-250<br>2023015000',
          comment: '4 位年份及月份用作编号前缀。',
        },
        {
          format: 'BU1-{00000000}',
          number: '1<br>250<br>5000',
          encodeNumber: 'BU1-00000001<br>BU1-00000250<br>BU1-00005000',
          comment: '以"BU1-"（包括中划线）为前缀',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList', 'getTenantInfo']),
    jurisdiction() {
      return {
        metaManage: this.getElementList.includes('meta-manage'),
      };
    },
    optionList: {
      get() {
        switch (this.formData.value_type) {
          case 'SELECT_ONE':
            return this.one_option;
          case 'SELECT_ONE_INT':
            return this.one_int_option;
          case 'SELECT_MANY':
            return this.many_optio;
          default:
            return [];
        }
      },
      set(value) {
        switch (this.formData.value_type) {
          case 'SELECT_ONE':
            this.one_option = value;
            break;
          case 'SELECT_ONE_INT':
            this.one_int_option = value;
            break;
          case 'SELECT_MANY':
            this.many_optio = value;
            break;
          default:
        }
      },
    },
    formRules() {
      if (this.formData.value_type === 'AUTO_NUMBER') {
        const checkAutoNumberOption = (rule, value, callback) => {
          const regs = this.fieldNameRegs;
          if (this.formData.value_type !== 'AUTO_NUMBER') {
            return callback();
          }
          if (value === '') {
            return callback(new Error('编码规则不能为空'));
          }
          const reg = /([^{}]{1,}|({0+}){1,}|({YY}){1,}|({YYYY}){1,}|({DD}){1,}|({MM}){1,}){1,}/;
          const mustHaveSequence = /{0+}+/;
          if (!mustHaveSequence.test(value)) {
            return callback(new Error('自动编码必须拥有序列编号'));
          }
          console.log('是否存在序列：', mustHaveSequence.test(value));
          if (!reg.test(value)) {
            return callback(new Error('编码规则不正确'));
          }
          console.log('是否符合规则：', mustHaveSequence.test(value));
          const fieldTestResults = regs.map((reg) => {
            return reg.test(value);
          });
          console.log('---fieldTestResults---', fieldTestResults);
          const fieldTestResult = fieldTestResults.reduce((acc, cur) => {
            return acc || cur;
          });
          if (!fieldTestResult) {
            return callback(new Error('无法获取字段'));
          }
          return callback();
        };
        return {
          format: [
            { validator: checkAutoNumberOption, trigger: 'blur' },
            { required: true, rigger: 'blur', message: '编码规则不能为空' },
          ],
        };
      }
      return {};
    },
    defineTypeOption() {
      let DefineType = [];
      Object.keys(this.DefineType).forEach((key) => {
        DefineType.push({
          label: this.DefineType[key],
          value: key,
        });
      });
      if (this.getTenantInfo.tenant_type === 'extend') {
        DefineType = DefineType.filter((item) => item.value === 'CUSTOM');
      }
      return DefineType;
    },
  },
  watch: {
    'formData.value_type'() {},
  },
  mounted() {
    this.queryParams.object_id = this.$route.query.object_id;

    this.getList();
    this.getEditingObject();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    humanifyDate(str) {
      return dayjs(str).format('lll');
    },
    relativeDate(str) {
      return dayjs(str).fromNow();
    },
    addDomain() {
      this.optionList = [...this.optionList, { value: '', label: '', class: '' }];
    },
    removeDomain(index) {
      if (index > this.oldOptionLen - 1) {
        this.optionList.splice(index, 1);
      }
    },
    saveOptions() {
      if (this.formData.value_type === 'SELECT_ONE') {
        this.formData.select_one_option = {
          options: copy(this.optionList),
        };
      } else if (this.formData.value_type === 'SELECT_MANY') {
        this.formData.select_many_option = {
          options: copy(this.optionList),
        };
      } else if (this.formData.value_type === 'SELECT_ONE_INT') {
        this.formData.select_one_int_option = {
          options: copy(this.optionList),
        };
      } else if (this.formData.value_type === 'TEXT') {
        const { set_mask: mask, mask_rule: rule, type } = this.text_option;
        this.formData.text_option = {
          type,
          set_mask: mask,
          mask_rule: mask ? rule : { pattern: '', replacement: '' },
        };
      }
    },
    getOptions() {
      if (this.formData.value_type === 'SELECT_ONE') {
        this.oldOptionLen = this.formData.select_one_option.options.length;
        this.optionList = this.formData.select_one_option.options;
      } else if (this.formData.value_type === 'SELECT_MANY') {
        this.oldOptionLen = this.formData.select_many_option.options.length;
        this.optionList = this.formData.select_many_option.options;
      } else if (this.formData.value_type === 'SELECT_ONE_INT') {
        this.oldOptionLen = this.formData.select_one_int_option.options.length;
        this.optionList = this.formData.select_one_int_option.options;
      } else if (this.formData.value_type === 'TEXT') {
        this.text_option = this.formData.text_option;
        this.disabledTextSubtype = true;
      } else if (this.formData.value_type === 'AUTO_NUMBER') {
        this.disabledDCR = true;
        this.disabledEncrypt = true;
      }
    },
    cearOption() {
      this.one_option = [{ value: '', label: '', class: '' }];
      this.many_optio = [{ value: '', label: '', class: '' }];
      this.one_int_option = [{ value: '', label: '', class: '' }];
      this.text_option = {
        set_mask: false,
        type: '',
        mask_rule: {
          pattern: '',
          replacement: '',
        },
      };
    },
    // 增加字段
    itemAdd() {
      this.formData = copy(FieldDefaults);
      this.formData.object_id = this.queryParams.object_id;
      this.formData.define_type =
        this.getTenantInfo.tenant_type === 'extend' ? 'CUSTOM' : 'PACKAGE';
      console.log('------this.formData------', this.formData);
      this.dialogVisible = true;
      this.dialogIsCreate = true;
      this.disabledTextSubtype = false;
      this.disabledIsUnique = false;
      this.disabledDCR = false;
      this.disabledEncrypt = false;
      this.oldOptionLen = -1;
    },
    // 编辑字段
    itemEdit(row) {
      const data = copy(row);
      this.formData = {
        ...data,
        format: data?.auto_number_option?.format || '',
        update_value: data?.auto_number_option?.update_value || false,
      };
      this.disabledDCR = false;
      this.disabledEncrypt = false;
      this.oldOptionLen = -1;
      this.disabledIsUnique = true;
      this.getOptions();
      this.dialogVisible = true;
      this.dialogIsCreate = false;
    },
    async itemDelete({ id }) {
      this.$request({
        url: this.$api.metaGetFieldIndexesByID,
        data: { id },
        cb: ({ index }) => {
          if (index.length > 0) {
            this.deleteField = id;
            // 展示索引信息
            this.indexList = index;
            this.$nextTick(() => {
              this.showIndexList = true;
            });
            return;
          }
          this.daleteData({ id });
        },
      });
    },
    // 删除再次询问弹窗
    async daleteData({ id = this.deleteField }) {
      await this.$confirm('删除该分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      // await DeleteField({ id });
      this.$request({
        url: this.$api.metaDeleteField,
        data: { id },
        cb: () => {
          this.showIndexList = false;
          this.getList();
        },
      });
    },
    handleCurrentChange(page) {
      // 翻页
      this.queryParams.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      // 一页显示条数修改
      this.queryParams.page_size = size;
      this.getList();
    },
    // 获取列表数据
    getList() {
      this.loading = true;
      this.$request({
        url: this.$api.metaGetObjectFields,
        data: this.queryParams,
        cb: ({ count, fields }) => {
          this.total = parseInt(count, 10);
          this.list = fields;
          this.loading = false;
          this.availableFieldName = this.list
            .filter((item) => {
              return ['INT', 'TEXT', 'SELECT_ONE_INT', 'FLOAT'].includes(item.value_type);
            })
            .map((item) => item.name);
          this.fieldNameRegs = this.availableFieldName.map((name) => {
            return new RegExp(
              `^([^{}]{1,}|({0+}){1,}|({YY}){1,}|({YYYY}){1,}|({DD}){1,}|({MM}){1,}|({${name}}){1,}){1,}$`,
            );
          });
          console.log('---availableFieldName---', this.availableFieldName);
          console.log('---fieldNameRegs---', this.fieldNameRegs);
        },
      });
    },
    // 关闭时，再次询问弹窗
    async dialogBeforeClose() {
      try {
        await this.$confirm('所作更改将不会被保存，确认关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.dialogVisible = false;
        this.cearOption();
      } catch (err) {
        console.log(err);
      }
    },
    onOpenAutoNumberInfo() {
      this.dialogVisible = false;
      this.autoNumberInfoDialogVisible = true;
    },
    onCloseInfoDialog() {
      this.dialogVisible = true;
    },
    applyKeywordFilter() {
      this.queryParams.offset = 1;
      this.getList();
    },
    submitForm(formName) {
      console.log('!!!!!!submitForm!!!!!!');
      this.$refs[formName].validate((valid) => {
        console.log('!!!!!!submitForm!!!!!!', valid);
        if (valid) {
          this.saveOptions();
          if (this.formData.value_type === 'TEXT') {
            try {
              if (this.text_option.set_mask) {
                console.log(new RegExp(this.text_option.mask_rule.pattern));
              }
            } catch (err) {
              console.log(err);
              this.$message.error('正则语法错误');
              return;
            }
          }
          const formData = copy(this.formData);
          if (formData.value_type === 'AUTO_NUMBER') {
            formData.auto_number_option = {
              format: formData.format,
              update_value: formData.update_value,
            };
            delete formData.text_option;
          }
          delete formData.format;
          delete formData.update_value;
          if (!formData.set_default) {
            formData.default = '';
          }
          const cb = () => {
            this.dialogVisible = false;
            this.cearOption();
            this.getList();
            this.$message.success('提交成功');
          };
          if (this.dialogIsCreate) {
            // await AddField({ field: formData });
            this.$request({
              url: this.$api.metaAddField,
              data: {
                field: {
                  ...formData,
                  name: formData.define_type === 'CUSTOM' ? `${formData.name}__c` : formData.name,
                },
              },
              cb,
            });
          } else {
            // await UpdateField({
            //     id: formData.id,
            //     field: formData,
            // });
            this.$request({
              url: this.$api.metaUpdateField,
              data: {
                id: formData.id,
                field: formData,
              },
              cb,
            });
            // await SetFieldEncrypt({
            //     id: formData.id,
            //     action: formData.encrypt ? 1 : 0,
            // });
            this.$request({
              url: this.$api.metaSetFieldEncrypt,
              data: {
                id: formData.id,
                action: formData.encrypt ? 1 : 0,
              },
              cb: () => {},
            });
          }
        } else {
          return false;
        }
      });
    },
    async getEditingObject() {
      const objectId = this.queryParams.object_id;
      this.$request({
        url: this.$api.metaGetObjectDetail,
        data: { id: objectId },
        cb: ({ object }) => {
          this.editingObject = object;
        },
      });
    },
  },
};
